import React from 'react';
import PropTypes from 'prop-types';
import useInstallApp from '../../../utils/useInstallApp';
import useIntl from '@afosto/utils-react/intl/useIntl';
import IntegrationForm from '../../../components/IntegrationForm';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import translations from './translations';

const EditIntegrationDrawer = ({ app, isOpen, onClose }) => {
  const intl = useIntl();
  const installApp = useInstallApp();

  const handleCreateIntegration = async data => installApp(app, data);

  return (
    <FormDrawer
      drawerWidth="420px"
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage(translations.title)}
    >
      <IntegrationForm app={app} onCancel={onClose} onSubmit={handleCreateIntegration} />
    </FormDrawer>
  );
};

EditIntegrationDrawer.propTypes = {
  app: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

EditIntegrationDrawer.defaultProps = {
  app: undefined,
  isOpen: false,
  onClose: undefined,
};

export default EditIntegrationDrawer;
